export default __webpack_public_path__ + "static/media/loading.fd28a59c.svg";